<template>
	<StandardModal
		open
		:title="$t('common_account_signedout_description')"
		:confirmText="$t('onboarding_splash_signin')"
		@confirm="$emit('signin')"
		@cancel="$emit('cancel')"
		small
	>
		<div class="modal-wrapper">
			<LockKeyholeIcon halo />
			<i18n-t
				keypath="common_account_signedout_title"
				class="loggedout-title"
				tag="div"
			>
				<template #OrgName>
					<strong v-text="org" />
				</template>
			</i18n-t>
		</div>
	</StandardModal>
</template>

<script>
import { StandardModal } from '@/components/common'
import { LockKeyholeIcon } from '@/icons'

export default {
	name: 'LoggedOutModal',
	components: { StandardModal, LockKeyholeIcon },
	props: {
		org: String,
	},
	emits: ['signin', 'cancel']
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.modal-wrapper {
	@include flex-column-center;
	max-width: 300px;
	margin: 24px auto;
	text-align: center;
	strong {
		@include fontFamily(800);
	}
	.pronto-icon {
		color: var(--blue-300);
		font-size: 50px;
		margin-bottom: 24px;
	}
}
</style>
